<template>
  <!-- 临期黄条：仅 Current Display 已生效 BR（产品规则） -->
  <div class="br-doc-item__warning">
    <img
      :src="iconUrl"
      class="br-doc-item__warning-icon"
      width="20"
      height="20"
      alt=""
    />
    <p class="br-doc-item__warning-text">{{ $t('lbl_EMPBE_BR_List_ExpiredSoon') }}</p>
  </div>
</template>

<script>
import { BR_LICENSE_ASSETS } from '../../../constants/brLicenseAssets';

export default {
  name: 'BrExpirySoonBar',
  computed: {
    iconUrl() {
      return BR_LICENSE_ASSETS.expirySoonAlertIcon;
    },
  },
};
</script>
